import {
  type CreatePulseMutation,
  type CreatePulseMutationVariables,
  type PulseRefFragment,
  type PulseV1PulseInput,
  isError,
  useCreatePulseMutation,
  withStandardCreateHook,
} from '@spotify/confidence-graphql';

import { prependPulseToPulsesCache } from './prependPulseToPulsesCache';

export const useCreatePulse = withStandardCreateHook<
  CreatePulseMutation,
  PulseRefFragment,
  'createPulse',
  CreatePulseMutationVariables,
  [PulseV1PulseInput, string | undefined]
>(
  useCreatePulseMutation,
  'createPulse',
  (pulse, pulseId) => ({
    pulse,
    ...(pulseId ? { pulseId } : {}),
  }),
  {
    update: (cache, { data }) => {
      const newPulse = data?.createPulse;
      if (!newPulse || isError(newPulse)) return;
      prependPulseToPulsesCache(cache, newPulse);
    },
  },
);
